import { Link } from "react-router-dom";
import { useHistory } from 'react-router';
import { FC, useState, useEffect } from 'react';

import * as API from 'api';
import * as Meta from 'meta';
import { ROUTE } from 'route';
import { gaEvent } from "utils";

import * as Type from 'components/InputContact/type';
import { Header, Footer, InputContact } from "components";

const mapPrizeID: {[key: number]: string} = {
  1: 'cup380',
  2: 'cup510',
  3: 'picnic',
  4: 'icebox',
  5: 'trunk',
};

let prizeID = 0;
let prizeName = '';

interface IUser {
  prize?: string;
  prize_id?: number;
  isWinner: boolean;
  isWritten?: boolean;
}
interface ICb {
  (user: IUser): void;
}

export const YouWinPage: FC = () => {
  const [isWinner, setIsWinner] = useState(false);
  const [haveFilled, setHaveFilled] = useState(false);
  const history = useHistory();

  const postIsWinner = (cb: ICb) => {
    fetch(API.isWinner(), {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({ishara: API.getToken()})
    }).then(res => {
      return res.json();
    }).then(json => {
      if(json.errors) return alert("error");
      cb && cb(json);
    });
  };

  useEffect(() => {
    postIsWinner((user: IUser) => {
      if(user.isWinner) {
        prizeName = user.prize;
        prizeID = user.prize_id;
      }
      setIsWinner(user.isWinner);
      user.isWritten && setHaveFilled(true);
      if(!user.isWinner) history.push(ROUTE.HOME);
    });
  }, []);

  const postContact = (data: Type.IContactData) => {
    gaEvent('中獎', '送出資料');
    fetch(API.winner(), {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify(data)
    }).then(res => {
      return res.json();
    }).then(json => {
      if(json.errors) return alert("error");
      setHaveFilled(true);
    });
  };

  if(!isWinner) return null;
  return (
    <div className="wrapper">
      {Meta.loadCSS(['success', 'notice'])}
      {Meta.loadJS(["main-0625"])}
      {Meta.ga("中獎結果頁")}
      <Header />
      <div className="main">
        <section className="success inner">
          <div className="success_box">
            <div className="page_text">恭喜<br />一抽爽中 暢快享有</div>
            <div className="success_top">
              <div className="success_pic">
                <div className="success_prize ms"><img src={`/resources/html/images/${mapPrizeID[prizeID]}.png`} /></div>
                <div className="success_surprise"><img src="/resources/html/images/success/surprise.png" /></div>
              </div>
              <div className="success_name mt">
                <p>{prizeName}</p>
              </div>
            </div>
          </div>
          <img className="success_left" src="/resources/html/images/intro/intro_left.png" />
          <img className="success_right" src="/resources/html/images/intro/intro_right.png" />
        </section>
        <section className="success_form">
          {haveFilled ?
            <div className="success_change inner">
              <div className="change_title">已收到您的資料</div>
              <div className="change_pic"><img src="/resources/html/images/success/p1.png" /></div>
              <div className="change_in">延續您的爽勁</div>
              <div className="success_btbox">
                <Link to={ROUTE.SCAN} onClick={gaEvent.bind(null, '中獎', '繼續掃描')}><div className="success_b">繼續掃描QRcode</div></Link>
              </div>
            </div>:
            <InputContact isWin func={postContact}/>
          }
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
